module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentZoom) ? _c('div', {
    attrs: {
      "id": "componentZoomSelect"
    }
  }, [_c('div', {
    class: {
      active: _vm.showOptions
    },
    on: {
      "click": function($event) {
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('i', {
    staticClass: "fa i fa fa-search mr-1"
  }), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Zoom: " + _vm._s(_vm.mapZoom))]), _c('i', {
    staticClass: "fa fa-angle-up"
  })]), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptions),
      expression: "showOptions"
    }],
    attrs: {
      "id": "options"
    }
  }, [_c('div', {
    staticClass: "h-100"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Zoom")]), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [(_vm.showOptions) ? _c('el-slider', {
    attrs: {
      "vertical": "vertical",
      "min": _vm.minZoom,
      "max": _vm.maxZoom
    },
    on: {
      "change": _vm.updateZoom
    },
    model: {
      value: (_vm.currentZoom),
      callback: function($$v) {
        _vm.currentZoom = $$v
      },
      expression: "currentZoom"
    }
  }) : _vm._e()], 1)])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb3d6464","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZoomSelect.vue
// module id = 495
// module chunks = 1